import { render, staticRenderFns } from "./reg-finish.vue?vue&type=template&id=684ecbe6&scoped=true"
import script from "./reg-finish.vue?vue&type=script&lang=js"
export * from "./reg-finish.vue?vue&type=script&lang=js"
import style0 from "./reg-finish.vue?vue&type=style&index=0&id=684ecbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ecbe6",
  null
  
)

export default component.exports